import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { getAllImpactCalculateForAllProjects } from '@/domain/impact-calculate-festival/actions/get-all-impact-calculate-festival-for-all-projects.action';
import { runImpactCalculateFestivalCo2ForProject } from '@/domain/impact-calculate-festival/actions/run-impact-calculate-festival-co2-for-project.action';
import { runImpactCalculateFestivalEnvForProject } from '@/domain/impact-calculate-festival/actions/run-impact-calculate-festival-env-for-project.action';
import { runImpactCalculateFestivalEssForProject } from '@/domain/impact-calculate-festival/actions/run-impact-calculate-festival-ess-for-project.action';
import { CalculateFestival } from '@/domain/impact-calculate-festival/entities/calculate-festival.entity';

export type ImpactCalculateFestivalState = {
  isFetching: boolean;
  byProjectId: {
    [key: number]: CalculateFestival;
  };
};

const initialState: ImpactCalculateFestivalState = {
  isFetching: false,
  byProjectId: {},
};

export const impactCalculateFestivalSlice = createSlice({
  name: 'impactCalculateFestival',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // co2
      .addCase(
        runImpactCalculateFestivalCo2ForProject.fulfilled,
        (state, action) => {
          const projectId: number = action.meta.arg.projectId;
          state.byProjectId[projectId] = {
            ...state.byProjectId[projectId],
            co2: action.payload.co2,
          };
        },
      )
      // env
      .addCase(
        runImpactCalculateFestivalEnvForProject.fulfilled,
        (state, action) => {
          const projectId: number = action.meta.arg.projectId;
          state.byProjectId[projectId] = {
            ...state.byProjectId[projectId],
            env: action.payload.env,
          };
        },
      )
      // ess
      .addCase(
        runImpactCalculateFestivalEssForProject.fulfilled,
        (state, action) => {
          const projectId: number = action.meta.arg.projectId;
          state.byProjectId[projectId] = {
            ...state.byProjectId[projectId],
            ess: action.payload.ess,
          };
        },
      )
      // all calculate of all projects
      .addCase(
        getAllImpactCalculateForAllProjects.fulfilled,
        (state, action) => {
          const obj = action.payload.reduce((prev, curr) => {
            return { ...prev, [curr.projectId]: curr.calculate };
          }, {});
          state.byProjectId = obj;
        },
      )
      // isFetching
      .addMatcher(
        isAnyOf(
          runImpactCalculateFestivalCo2ForProject.pending,
          runImpactCalculateFestivalEnvForProject.pending,
          runImpactCalculateFestivalEssForProject.pending,
          getAllImpactCalculateForAllProjects.pending,
        ),
        (state) => {
          state.isFetching = true;
        },
      )
      .addMatcher(
        isAnyOf(
          runImpactCalculateFestivalCo2ForProject.fulfilled,
          runImpactCalculateFestivalCo2ForProject.rejected,
          runImpactCalculateFestivalEnvForProject.fulfilled,
          runImpactCalculateFestivalEnvForProject.rejected,
          runImpactCalculateFestivalEssForProject.fulfilled,
          runImpactCalculateFestivalEssForProject.rejected,
          getAllImpactCalculateForAllProjects.fulfilled,
          getAllImpactCalculateForAllProjects.rejected,
        ),
        (state) => {
          state.isFetching = false;
        },
      );
  },
});
